import { mainApi } from '../../../../api';

export default {
  namespaced: true,

  state: {
    listWorkPlaces  : null,
    specializations : null,
    listCountries   : null
  },

  mutations: {
    SET_LIST_WORK_PLACES(state, payload) {
      if (payload && payload.length) {
        state.listWorkPlaces = payload.map((el) => ({ label: el.name, value: el.name }));
      }
    },
    SET_SPECIALIZATIONS(state, payload) {
      if (payload && payload.length) {
        state.specializations = payload.map((el) => {
          const result = {
            id    : el.id,
            label : el.value,
            value : el.xml_id
          };

          if (el.children && el.children.length) {
            result.children = el.children.map((child) => ({
              id    : child.id,
              label : child.value,
              value : child.xml_id
            }));
          }

          return result;
        });
      }
    },
    SET_LIST_COUNTRIES(state, payload) {
      if (payload && payload.length) {
        state.listCountries = payload.map((el) => ({
          label      : el.name,
          value      : el.id,
          country    : el.iso2,
          locationId : el.location_id
        }));
      }
    }
  },

  actions: {
    async getWorkPlaces(context, payload) {
      return new Promise((resolve, reject) => {
        mainApi.modules.authorization.getWorkPlaces(payload).then(({ data }) => {
          context.commit('SET_LIST_WORK_PLACES', data);
          resolve(data);
        }).catch(reject);
      });
    },

    async getSpecializations(context, payload) {
      return new Promise((resolve, reject) => {
        mainApi.modules.authorization.getSpecs(payload).then(({ data }) => {
          context.commit('SET_SPECIALIZATIONS', data);
          resolve(data);
        }).catch(reject);
      });
    },

    async getListCountries(context) {
      return new Promise((resolve, reject) => {
        mainApi.modules.common.getLocations().then((data) => {
          context.commit('SET_LIST_COUNTRIES', data.availableCountries);
          resolve(data);
        }).catch(reject);
      });
    }
  },

  getters: {
    listWorkPlaces  : (state) => state.listWorkPlaces,
    specializations : (state) => state.specializations,
    listCountries   : (state) => state.listCountries
  }
};
